import { Card } from '@cmsgov/ds-medicare-gov'
import { CardStack, CardStackItem } from 'components/CardStack/CardStack'
import { useTranslation } from 'react-i18next'

export function MaPartDIrmaaCardStack (props: {className?: string, isPartCorD?: boolean, isPartDIRMAA?: boolean}) {
  const { className, isPartCorD, isPartDIRMAA } = props
  const { t } = useTranslation('makeAPaymentPage', { keyPrefix: 'beforeYouPay.infoCards' })

  if (!isPartCorD && !isPartDIRMAA) return null

  return (
    <CardStack className={className}>
      {isPartCorD && (
        <CardStackItem>
          <Card className="ds-u-padding--3">
            <h3 className="ds-text-heading--lg">
              {t('ma.heading')}
            </h3>
            <p>{t('ma.content')}</p>
          </Card>
        </CardStackItem>
      )}
      {isPartDIRMAA && (
        <CardStackItem>
          <Card className="ds-u-padding--3">
            <h3 className="ds-text-heading--lg">
              {t('partDIrmaa.heading')}
            </h3>
            <p>{t('partDIrmaa.content')}</p>
          </Card>
        </CardStackItem>
      )}
    </CardStack>
  )
}
